import { useEffect, useState, useCallback } from "react";

import { AmplitudeEvents } from "../../constants/amplitude";
import { useAmplitude } from "../../hooks/amplitude/useAmplitude";

import { useTextFieldWithCopyIcon } from "./useTextFieldWithCopyIcon";

export interface TextFieldInputProps {
  "data-test"?: string;
  value: string | null;
  onCopy?: () => void;
  additionalButtonGroup?: React.ReactNode;
  multiline?: boolean;
  button?: boolean;
  copyAmplitudeEvent?: AmplitudeEvents;
  copyAmplitudePayload?: Record<string, unknown>;
  copyButtonBelow?: boolean;
}

const useTextFieldWithCopy = ({ onCopy, copyAmplitudeEvent, copyAmplitudePayload }: TextFieldInputProps) => {
  const [textInput, setTextInput] = useState<HTMLInputElement | null>(null);
  const { disableChange, selectFullLink, handleLinkCopy } = useTextFieldWithCopyIcon(textInput, onCopy);
  const { logAmplitudeEvent } = useAmplitude();

  useEffect(() => {
    const handleCopyEvent = () => {
      if (copyAmplitudeEvent) {
        logAmplitudeEvent(copyAmplitudeEvent, copyAmplitudePayload);
      }
      onCopy?.();
    };

    if (textInput) {
      textInput.addEventListener("copy", handleCopyEvent);
    }

    return () => {
      if (textInput) {
        textInput.removeEventListener("copy", handleCopyEvent);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [textInput]);

  const handleSetInputRef = useCallback((currentInputRef: HTMLInputElement) => setTextInput(currentInputRef), []);

  return {
    disableChange,
    selectFullLink,
    handleLinkCopy,
    handleSetInputRef,
  };
};

export default useTextFieldWithCopy;
